import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import Button from '@Components/Button';
import './LoginPromptDialog.scss';

function LoginPromptDialog(props) {
  const { selfClose, onSignInClick } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className="remote-access-login-prompt-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      headerClassName="remote-access-login-prompt-dialog__header rx-border-none"
      header={<h4>Remote access</h4>}
      footerClassName="remote-access-login-prompt-dialog__footer rx-border-none"
      footer={
        <div className="els-btn-group-right">
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              label: 'Cancel',
              e2eName: 'remote-access-login-prompt-dialog-cancel',
              color: 'blue',
            }}
            onClick={selfClose}
          />
          <Button
            buttonConfig={{
              type: 'primary',
              size: 'sm',
              label: 'Sign in',
              e2eName: 'remote-access-login-prompt-dialog-sign-in',
            }}
            onClick={() => {
              onSignInClick();
              selfClose();
            }}
          />
        </div>
      }
      contentClassName="remote-access-login-prompt-dialog__content">
      The activation of remote access can be done when you are signed in. Please sign in and try again.
    </GeneralDialogLayout>
  );
}

LoginPromptDialog.defaultProps = {
  onSignInClick: () => {},
};

LoginPromptDialog.propTypes = {
  selfClose: PropTypes.func,
  onSignInClick: PropTypes.func,
};

export default LoginPromptDialog;
